<template>
  <div class="app-checkout-summary">
    <div class="summary--header"><slot name="txtHeadline"><h2>Lorem ipsum</h2></slot></div>
    <div class="summary--body">
      <div v-if="isMNPOrder" class="mnp-data card" tabindex="0">
        <MNP>
          <template v-for="slot in possibleChildSlotsFor('Mnp')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </MNP>
        <button type="button" :aria-label="getSlotText('ariaLabelEditButtonMnp')" @click="$emit('onStepClick', 'mnpData')" class="edit-icon icon-only">
          <img src="/files/flash/images/svg-icons/pen.svg" alt="bearbeiten" aria-hidden="true">
        </button>
      </div>
      <div class="customer-data card">
        <Customer>
          <template v-for="slot in possibleChildSlotsFor('Customer')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Customer>
        <button type="button" :aria-label="getSlotText('ariaLabelEditButtonCustomer')" @click="$emit('onStepClick', 'customerData')" class="edit-icon icon-only">
          <img src="/files/flash/images/svg-icons/pen.svg" alt="bearbeiten" aria-hidden="true">
        </button>
      </div>
      <div v-if="isMNPOrder && mnpContractHolderActive" class="customer-data card">
        <ContractHolder :mnp-contract-holder="mnpContractHolder">
          <template v-for="slot in possibleChildSlotsFor('Contract')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ContractHolder>
        <button type="button" :aria-label="getSlotText('ariaLabelEditButtonContract')" @click="$emit('onStepClick', 'customerData')" class="edit-icon icon-only">
          <img src="/files/flash/images/svg-icons/pen.svg" alt="bearbeiten" aria-hidden="true">
        </button>
      </div>
      <div class="sim-data card">
        <Sim>
          <template v-for="slot in possibleChildSlotsFor('Sim')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
          <template v-for="slot in possibleChildSlotsFor('Ident')" v-slot:[`${slot.parent}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Sim>
        <button type="button" :aria-label="getSlotText('ariaLabelEditButtonSim')" @click="$emit('onStepClick', 'simData')" class="edit-icon icon-only">
          <img src="/files/flash/images/svg-icons/pen.svg" alt="bearbeiten" aria-hidden="true">
        </button>
      </div>
      <div class="payment-data card">
        <Payment>
          <template v-for="slot in possibleChildSlotsFor('Payment')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Payment>
        <button type="button" :aria-label="getSlotText('ariaLabelEditButtonPayment')" @click="$emit('onStepClick', 'paymentData')" class="edit-icon icon-only">
          <img src="/files/flash/images/svg-icons/pen.svg" alt="bearbeiten" aria-hidden="true">
        </button>
      </div>
      <div class="summary--cart">
        <Cart :promoBenefits="promoBenefits" :voucherPromotions="voucherPromotions" :showPriceStarts="showPriceStarts" class="card">
          <template v-for="slot in possibleChildSlotsFor('Cart')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
          <template v-for="voucherSlot in possibleChildSlotsFor('VoucherSlots')" v-slot:[`${voucherSlot.child}`]>
            <slot :name="`${voucherSlot.parent}`"></slot>
          </template>
        </Cart>
        <VoucherBox class="card" @open-collapse="$refs.tokenHandlerRef.openCollapse()">
          <template v-for="slot in possibleChildSlotsFor('VoucherBox')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
          <template v-for="tokenSlot in possibleChildSlotsFor('TokenHandler')" v-slot:[`${tokenSlot.child}`]>
            <slot :name="`${tokenSlot.parent}`"></slot>
          </template>
          <template v-for="voucherSlot in possibleChildSlotsFor('VoucherSlots')" v-slot:[`${voucherSlot.child}`]>
            <slot :name="`${voucherSlot.parent}`"></slot>
          </template>
        </VoucherBox>
        <TokenHandler class="card" ref="tokenHandlerRef">
          <template v-for="slot in possibleChildSlotsFor('TokenHandler')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
          <template v-for="voucherSlot in possibleChildSlotsFor('VoucherSlots')" v-slot:[`${voucherSlot.child}`]>
            <slot :name="`${voucherSlot.parent}`"></slot>
          </template>
        </TokenHandler>
      </div>
      <div class="summary--consents">
        <form>
          <ConsentWrapper
            :consentAGB.sync="consent.agb"
            :selectedInfoExchangeConsent.sync="consent.exchange"
            :selectedContactConsent.sync="consent.contact"
            :contractTermsVersion.sync="consent.contractTermsVersion"
            :process="process"
          >
            <template v-for="slot in possibleChildSlotsFor('Consent')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </ConsentWrapper>
        </form>
      </div>
    </div>
    <Stepper
      :loading-next="loading"
      :show-prev="true"
      @prev="$emit('goBack')"
      @next="order()"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import Stepper from '@/components/generic/Stepper.vue'
import Cart from '@/components/checkout/cart/Cart.vue'
import MNP from '@/components/checkout/summary/MNP.vue'
import Customer from '@/components/checkout/summary/Customer.vue'
import ContractHolder from '@/components/checkout/summary/ContractHolder.vue'
import Sim from '@/components/checkout/summary/Sim.vue'
import Payment from '@/components/checkout/summary/Payment.vue'
import ConsentWrapper from '@/components/checkout/summary/Consent/ConsentWrapper.vue'
import trackingHandler from '@/mixins/trackingHandler'
import TokenHandler from '@/components/checkout/cart/TokenHandler.vue'
import transformElements from '@/mixins/transformElements'
import VoucherBox from '@/components/checkout/cart/VoucherBox.vue'

export default {
  name: 'Summary',
  components: {
    VoucherBox,
    TokenHandler,
    ConsentWrapper,
    Payment,
    ContractHolder,
    Sim,
    Customer,
    MNP,
    Cart,
    Stepper
  },
  data () {
    return {
      loading: false,
      consent: {
        agb: false,
        exchange: false,
        contact: false,
        contractTermsVersion: null
      }
    }
  },
  props: {
    process: {
      type: String,
      default: 'ordering'
    },
    promoBenefits: {
      type: Object,
      default: null
    },
    showPriceStarts: {
      type: Boolean,
      default: true
    },
    voucherPromotions: {
      type: Array,
      default: () => { return [] }
    }
  },
  mixins: [
    trackingHandler,
    transformElements
  ],
  mounted () {
    this.transformDivToLink('link_contract_summary')
  },
  methods: {
    async initiate () {
      this.startLoader()

      try {
        await this.$store.dispatch('checkoutv2/' + this.process + '/initiate')
      } catch (error) {
        this.errorToast(this.getErrorMessage(error))
        this.triggerErrorTracking(error)
      } finally {
        this.stopLoader()
      }
    },
    order () {
      const _this = this
      let successUrl = ''
      if (this.identData.identType) {
        successUrl = this.getSlotText('urlSuccessWithIdent')
      } else {
        successUrl = this.getSlotText('urlSuccess')
      }

      this.startLoader()
      _this.showBackendError = false
      _this.loading = true
      this.$store.dispatch('checkoutv2/' + this.process + '/confirm', this.consent).then(() => {
        _this.loading = false
        window.location.href = successUrl
      }).catch((error) => {
        _this.loading = false
        this.errorToast(this.getErrorMessage(error))
        this.triggerErrorTracking(error)
      })
        .finally(() => {
          this.stopLoader()
        })
      return true
    }
  },
  watch: {
    voucherCode: {
      handler: function () {
        this.initiate()
      }
    },
    targetTariff: { // adding or deleting kwk token will change the target tariff
      handler: function () {
        this.initiate()
      }
    }
  },
  computed: {
    isMNPOrder () {
      return this.$store.getters['checkoutv2/' + this.process + '/_mnpData/active'] === true
    },
    mnpContractHolderActive () {
      return this.mnpContractHolder?.active
    },
    mnpContractHolder () {
      return this.$store.getters['checkoutv2/' + this.process + '/_mnpData/contractHolder'] || null
    },
    identData () {
      return this.$store.getters['checkoutv2/' + this.process + '/_identData/identData'] || null
    },
    kwkToken () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/kwkToken'] || null
    },
    targetTariff () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/targetTariff'] || null
    },
    voucherCode () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/voucherCode'] || null
    }
  }
}
</script>
